<template>
    <div class="h-full">
        <div  v-show="!config.isDetailDisplay" :class="config.isDetailDisplay ? 'small-list' : 'scroll-auto'">
            <Control ref="control" :config="config" @onChangeEditDataSource="onChangeEditDataSource"></Control>
        </div>
        <div v-show="config.isDetailDisplay" class="detail">
            <EditControl :dataSource="editDataSource" :config="config"></EditControl>
        </div>
    </div>
</template>

<script>
    export default {
        data(){
            return {
                config: {
                    isDetailDisplay:false,
                    dataSourceKey:0
                },
                editDataSource: {
                },
                initialDataSource: {}
            }
        },
        methods: {
            onChangeEditDataSource: function (dataSourceKey) {
                this.config.isAdd = (!dataSourceKey);
                this.config.dataSourceKey = dataSourceKey;
            },
            syncDataSource(){
                this.initialDataSource = this.Utils.extend({},this.editDataSource);
            },
            back() {
                this.config.isDetailDisplay = false;
            }
        },
        components: {
            "EditControl": resolve => { require(['./components/edit.vue'], resolve) },
            "Control": resolve => { require(['./components/list.vue'], resolve) },
        }
    }
</script>

<style>

</style>